import { Capacitor } from "@capacitor/core";

// El reCAPTCHA v2 (checkbox) no funciona dentro del WebView nativo de Capacitor:
// Android le niega el requestStorageAccess que el iframe de Google necesita para
// verificar, así que el checkbox nunca se resuelve. En la app nativa lo omitimos
// y confiamos en el rate-limit del backend en su lugar.
export const isNativeApp = Capacitor.isNativePlatform();
